<boi-kfi-section-navigation #boiTabWrapper (detectChanges)="changeDetectorRef.detectChanges()">
  <div class="kfi-title-bar">
    <h2 class="bo-title-text vo-heading-regular-22">{{referenceDataLabels.SectionTitleMortgage | localizeLabel}}</h2>
    <span class="required-label vo-display-none">{{referenceDataLabels.MandatoryFields|localizeLabel}}</span>
  </div>
  <boi-form-information-box [message]="referenceDataLabels.MortgageDescription"></boi-form-information-box>

  <boi-accordion>
    <boi-accordion-item
      #accordionItem1
      [title]="referenceDataLabels.AboutTheMortgageId | localizeLabel"
      [class]="'js-section-' + referenceDataLabels.AboutTheMortgageId | removeWhiteSpaces"
      [data]="sections.YourMortgage.AboutYourMortgage"
    >
      <boi-progress-stepper-item
        header
        [status]="sections.YourMortgage.AboutYourMortgage"
        [hasSubmitValidationError]="hasSubmitValidationError"
      >
      </boi-progress-stepper-item>
      <boi-kfi-about-the-mortgage-control [kfi]="kfi" (isFeeUpToDateChange)="isFeeUpToDate = $event">
      </boi-kfi-about-the-mortgage-control>
      <boi-save-kfi
        class="buttons__bar"
        [saveButtonLabel]="referenceDataLabels.SaveContinueId"
        [isFieldDisabled]="kfi.IsApplicationReadOnly"
        (cancel)="boiTabWrapper.goToSection(referenceDataLabels.AboutTheMortgageId)"
        (save)="isFeeUpToDate = true; kfi.Fee && boiTabWrapper.goToNextIncompleted(accordionItem1)"
      ></boi-save-kfi>
    </boi-accordion-item>
    <div class="vo-separator-line my-15"></div>
    <boi-accordion-item
      #accordionItem2
      *ngIf="kfi.Fee"
      [title]="referenceDataLabels.AboutTheFeesId | localizeLabel"
      [class]="'js-section-' + referenceDataLabels.AboutTheFeesId | removeWhiteSpaces"
      [data]="sections.YourMortgage.AboutTheFees"
    >
      <boi-progress-stepper-item
        header
        [status]="sections.YourMortgage.AboutTheFees"
        [hasSubmitValidationError]="hasSubmitValidationError"
      >
      </boi-progress-stepper-item>
      <boi-fees [application]="kfi" [isFeeUpToDate]="isFeeUpToDate" [isDprEnabled]="isDprEnabled"> </boi-fees>
      <boi-save-kfi
        class="buttons__bar"
        [saveButtonLabel]="referenceDataLabels.SaveContinueToNextStepId"
        [isFieldDisabled]="kfi.IsApplicationReadOnly"
        (cancel)="boiTabWrapper.goToSection(referenceDataLabels.AboutTheFeesId)"
        (save)="boiTabWrapper.goToNextIncompleted(accordionItem2)"
      ></boi-save-kfi>
    </boi-accordion-item>
  </boi-accordion>
</boi-kfi-section-navigation>
